<template>
  <div>
    <v-container class="my-7" v-if="!loading">
      <banner type="top" class="mb-7" />

      <Title no-decoration>{{ title }}</Title>

      <div v-if="totalItems" class="magazine-list mt-6">
        <v-card
          class="magazine"
          :href="to"
          target="_blank"
          v-for="({ img, title, to }, i) in items"
          :key="i"
          tile
          flat
        >
          <img :src="img" :alt="title" />
          <div class="magazine-title mt-3" v-if="title">
            {{ title }}
          </div>
        </v-card>

        <v-pagination
          v-model="page"
          :length="pagesLength"
          :total-visible="9"
          v-if="pagesLength > 1"
        ></v-pagination>
      </div>
      <v-alert v-else name="warn" type="warning" class="mt-6">
        Nenhum conteúdo adicionado até o momento.
      </v-alert>

      <banner type="center-2" class="mt-12" />
    </v-container>
    <v-sheet
      v-else
      class="d-flex justify-center align-center my-16"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-sheet>
  </div>
</template>

<script>
import Banner from "@/components/cards/Banner.vue";
import Title from "@/components/widgets/Title.vue";

const _config = {
  title: "Revistas",
  mod: "magazine",
  itemsPerPage: 24,
};

export default {
  data: () => ({
    loading: true,
    items: [],
    totalItems: 0,
    title: _config.title,
  }),
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
    pagesLength() {
      return Math.ceil(this.totalItems / _config.itemsPerPage);
    },
  },
  created() {
    this.get();
  },
  watch: {
    page() {
      this.get();
    },
  },
  methods: {
    get() {
      const params = {
        itemsPerPage: _config.itemsPerPage,
        returnTotalItems: 1,
      };

      if (this.page) params.page = this.page;

      this.loading = true;

      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, { totalItems, list }) => {
            this.items = list.map(({ id, img, title }) => ({
              img: this.files + img,
              title,
              to: `https://revista.revistanoticiamt.com.br/${id}`,
            }));
            this.totalItems = totalItems;

            if (!list.length && this.page > 1) this.page = 1;
          },
        })
        .then(() => (this.loading = false));
    },
  },
  components: {
    Banner,
    Title,
  },
};
</script>

<style scoped>
.magazine-list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 30px;
}

.magazine {
  width: 100%;
}

.magazine img {
  aspect-ratio: 270 / 350;
  display: block;
  object-fit: cover;
  -o-object-fit: cover;
  object-position: center;
  -o-object-position: center;
  width: 100%;
}

@media screen and (max-width: 960px) {
  .magazine-list {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media screen and (max-width: 600px) {
  .magazine-list {
    grid-template-columns: 1fr 1fr;
    gap: 30px 10px;
  }
}
</style>
